"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YoutubeChannelsService = void 0;
const tslib_1 = require("tslib");
const youtube_1 = require("@wix/wix-vod-api-site-based/dist/src/public/services/youtube/youtube");
const common_1 = require("@wix/wix-vod-constants/common");
const api_types_1 = require("@wix/wix-vod-constants/api-types");
const to_error_1 = require("../../parsers/to-error");
const get_thumbnail_1 = tslib_1.__importDefault(require("./parsers/get-thumbnail"));
const channel_1 = require("./parsers/channel");
class YoutubeChannelsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.youtubeService = new youtube_1.YoutubeService(httpClient);
    }
    getChannelsByIds(ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.youtubeService
                .getChannelsByIds(ids)
                .then((response) => _.map(response.data.items, (channel) => (0, channel_1.parseYoutubeChannel)(common_1.URL_TYPES.CHANNEL, channel)))
                .then((channels) => this.setMissingCovers(channels))
                .then((channels) => {
                const realIds = _.map(channels, 'externalId');
                return [
                    ...channels,
                    ...this.extendWithRemovedItems(ids, realIds, common_1.URL_TYPES.CHANNEL),
                ];
            })
                .then((channels) => ({ data: channels }))
                .catch(to_error_1.toError);
        });
    }
    getChannelsByUserName(userName) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.youtubeService
                .getChannelsByUsername(userName)
                .then((response) => _.map(response.data.items, (channel) => (0, channel_1.parseYoutubeChannel)(common_1.URL_TYPES.CHANNEL, channel)))
                .then((channels) => this.setMissingCovers(channels))
                .then((channels) => ({ data: channels }))
                .catch(to_error_1.toError);
        });
    }
    getPlaylistsByIds(ids) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.youtubeService
                .getPlayListsByIds(ids)
                .then((response) => _.map(response.data.items, (channel) => (0, channel_1.parseYoutubeChannel)(common_1.URL_TYPES.PLAYLIST, channel)))
                .then((playlists) => {
                const realIds = _.map(playlists, 'externalId');
                return [
                    ...playlists,
                    ...this.extendWithRemovedItems(ids, realIds, common_1.URL_TYPES.PLAYLIST),
                ];
            })
                .then((playlists) => ({ data: playlists }))
                .catch(to_error_1.toError);
        });
    }
    extendWithRemovedItems(originalIds, realIds, urlType) {
        const removedIds = _.difference(originalIds, realIds);
        return _.map(removedIds, (id) => (0, channel_1.parseYoutubeChannel)(urlType, {
            id,
            isExternalRemoved: true,
        }));
    }
    getChannelsByUrl(url) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let type;
            let id;
            try {
                const result = this.youtubeService.parseChannelUrl(url);
                type = result.type;
                id = result.id;
            }
            catch (e) {
                return Promise.reject(new api_types_1.InternalError(0, 'wpm_error.malformed_external_link'));
            }
            switch (type) {
                case common_1.URL_TYPES.PLAYLIST:
                    return this.getPlaylistsByIds([id]);
                case common_1.URL_TYPES.USER_NAME:
                    return this.getChannelsByUserName(id);
                default:
                    return this.getChannelsByIds([id]);
            }
        });
    }
    // 1. get all youtube channels without cover
    // 2. fetch covers for from related playlists
    // 3. extend with covers
    // TODO: filter youtube channels only before applying this
    setMissingCovers(channels) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const channelsWithoutCovers = _.reject(channels, 'coverUrl');
            if (_.isEmpty(channelsWithoutCovers)) {
                return channels;
            }
            const playListIds = _.map(channelsWithoutCovers, 'uploadsPlaylistId');
            const videoCovers = yield this.getFallbackCovers(playListIds);
            _.forEach(channelsWithoutCovers, (channel, index) => {
                channel.coverUrl = videoCovers[index] || null;
            });
            return channels;
        });
    }
    getCoverFromPlaylistItem(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.youtubeService
                .getPlaylistItems({
                urlType: common_1.URL_TYPES.PLAYLIST,
                externalId: id,
                itemsCount: 1,
            })
                .then((response) => response.data.items[0])
                .then((item) => (item ? (0, get_thumbnail_1.default)(item.snippet.thumbnails) : null));
        });
    }
    getFallbackCovers(playlistIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const requests = _.map(playlistIds, (id) => this.getCoverFromPlaylistItem(id).catch(() => null));
            return Promise.all(requests);
        });
    }
}
exports.YoutubeChannelsService = YoutubeChannelsService;
//# sourceMappingURL=youtube-channels-service.js.map